import React, { useEffect, useState } from "react";
import { Container, EachRow, Editor, HeadRow, MainDiv } from "./style";
import { BoldMed, RegLg, RegMed } from "../../../../Components/CustomStyles";
import CloseIcon from "@mui/icons-material/Close";
import Colors from "../../../../Constant/Colors";
import RichTextEditor from "react-rte";
import IconButton from "../../../../Components/IconButton";
import { useDispatch } from "react-redux";
import { sendMailRequest } from "../../../../Redux/actions/home";

const NewMail = ({ closeNewMail, onChange, replyTo, setReplyTo }) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(RichTextEditor.createEmptyValue());
  const [isDisabled, setIsDisabled] = useState(false)
  const [formData, setFormData] = useState({
    subject: '',
    recipents: '',
    body: '',
  });
  const formUpdate = (key, value) => {
    setFormData(prev => ({
      ...prev,
      [key]: value
    }))
  };
  const handleChange = (newValue) => {
    setValue(newValue);
    const stripHtml = (html) => {
      var tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || "";
    };
    const plainText = stripHtml(newValue.toString("html"));
    formUpdate("body", plainText);
    if (onChange) {
      onChange(newValue.toString("html"));
    }
  };

  const sendMail = () => {
    setIsDisabled(true)
    let data = formData
    data['body'] = value?._cache?.html
    dispatch(sendMailRequest(formData));
    setFormData({
      body: "",
      recipents: "",
      subject: "",
    });
    setValue(RichTextEditor.createEmptyValue());
    // closeNewMail()
    if (replyTo?.id) setReplyTo(null)
    setTimeout(() => setIsDisabled(false), 1000)

  };
  const styles = {
    input: {
      border: "none",
      backgroundColor: Colors.whiteThemeColor,
      outline: "none",
      fontSize: 15,
      color: Colors.lightTxt,
      width: '100%',
    },
  };

  useEffect(() => {
    if (replyTo?.id) {
      setFormData({
        recipents: replyTo?.sender?.email,
        subject: `Re: ${replyTo?.subject}`,
      });
    }

  }, [replyTo])
  return (
    <Container>
      <MainDiv>

        <HeadRow>
          <BoldMed style={{ color: "#fff" }}>New Mail</BoldMed>
          <span onClick={closeNewMail}>
            <CloseIcon style={{ cursor: "pointer", color: "#fff" }} />
          </span>
        </HeadRow>
        <EachRow>
          <input
            type="mail"
            placeholder="Recipients"
            value={formData?.recipents}
            onChange={(e) => formUpdate("recipents", e.target.value)}
            style={styles.input}
          />
        </EachRow>
        <EachRow>
          <input
            type="text"
            placeholder="Subject"
            value={formData?.subject}
            onChange={(e) => formUpdate("subject", e.target.value)}
            style={styles.input}
          />
        </EachRow>
        <Editor style={{ height: "100%" }}>
          <RichTextEditor
            value={value}
            onChange={handleChange}
            toolbarClassName="toolbar"
            editorClassName="editor"
          />
        </Editor>

        <IconButton
          text={"Send"}
          style={{ width: 100, borderRadius: 5, padding: 5, margin: 10 }}
          onClick={sendMail}
          disabled={!formData.recipents || !formData.subject || !formData.body || isDisabled}
        />
      </MainDiv>

    </Container>
  );
};

export default NewMail;
